import React from 'react'
import DropDownList from './../DropDownList'
import Search from './../Search'
import { useGeoState } from '../GeoProvider'
import styles from './MapOptions.module.scss'
import dayjs from 'dayjs'

const MapOptions = ({
  regionDisplayOptions,
  activeCbsa,
  entity,
  activeZip3,
  searchPlaceholder = 'Search State, MSA or Zip 3',
  datatype,

}) => {
  let displayDateWeekEnd = dayjs().day(13).format('YYYY-MM-DD')
  const { regionSelected, setRegionSelected, setDisplayDate, displayDate,
    exportButtonState,setExportButtonState,exportButtonEnable } =
    useGeoState()
  const [searchCriteria, setSearchCriteria] = React.useState([])

  const handleClick = () => {
    setExportButtonState(true)
  }
  return (
    <div className={styles.base}>
      <div className={ entity === 'flu' || datatype==='flumeter'?styles.pageRegionListFlu:styles.pageRegionList}>
        <DropDownList
          id="regions"
          name="regions"
          onChange={(e) => {
            // history({ hash: null })
            setRegionSelected(e.target.value)
            if (
              displayDate > displayDateWeekEnd &&
              e.target.value !== 'zip3' &&
              entity !== 'vulnerability'
            ) {
              setDisplayDate(displayDateWeekEnd)
            }
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
      </div>
      <div className={styles.pageHeaderSearch}>
        {activeCbsa !== undefined &&
          activeZip3 !== undefined &&
          (entity === 'flu' || datatype==='flumeter') && (
            <Search
              criteria={searchCriteria}
              onChange={setSearchCriteria}
              entity={entity}
              activeMetros={activeCbsa}
              activeZip3={activeZip3}
              showZip3={true}
            />
          )}

        {activeCbsa !== undefined && entity !== 'flu' && (
          <Search
            criteria={searchCriteria}
            onChange={setSearchCriteria}
            placeholder={searchPlaceholder}
            entity={entity}
            activeMetros={activeCbsa}
            activeZip3={null}
          />
        )}
      </div>
      { (entity.toLowerCase() === 'flu' && datatype!=='flumeter') &&
      <div className={styles.pageHeaderExport}>
        {exportButtonState===true || regionSelected=='zip3' ||exportButtonEnable===false?
         <button className={styles.buttonClassDisable}>Export</button>:
        <button className={styles.buttonClass} onClick={() => {handleClick()}}>Export</button>
          }
       
      </div>
      }   

       { entity.toUpperCase() === 'COVID' &&
      <div className={styles.pageHeaderExport}>
        {exportButtonState===true || exportButtonEnable===false?
         <button className={styles.buttonClassDisable}>Export</button>:
         <button className={styles.buttonClass} onClick={() => {handleClick()}}>Export</button>
          }
       
      </div>
      }

       { entity.toLowerCase() === 'rsv' &&
      <div className={styles.pageHeaderExport}>
        {exportButtonState===true || exportButtonEnable===false?
         <button className={styles.buttonClassDisable}>Export</button>:
         <button className={styles.buttonClass} onClick={() => {handleClick()}}>Export</button>
          }
       
      </div>
      }
       { entity.toLowerCase() === 'vulnerability' &&
      <div className={styles.pageHeaderExport}>
        {exportButtonState===true || exportButtonEnable===false?
         <button className={styles.buttonClassDisable}>Export</button>:
         <button className={styles.buttonClass} onClick={() => {handleClick()}}>Export</button>
          }
       
      </div>
      }
    </div>
  )
}

export default MapOptions
